import { render, staticRenderFns } from "./DeleteProduct.vue?vue&type=template&id=403dd762&scoped=true"
import script from "./DeleteProduct.vue?vue&type=script&lang=js"
export * from "./DeleteProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403dd762",
  null
  
)

export default component.exports